import { render, staticRenderFns } from "./ReplyBookRspToLeavePg.vue?vue&type=template&id=18a13682&scoped=true"
import script from "./ReplyBookRspToLeavePg.vue?vue&type=script&lang=ts"
export * from "./ReplyBookRspToLeavePg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a13682",
  null
  
)

export default component.exports